import { useAuth } from "../context/AuthProvider";
import {Link} from "react-router-dom";
import React, { useState } from 'react';
import DeleteModal from '../cors/DeleteModal'; 
import { toast } from 'sonner';
import { BASE_URL } from '../apiConfig';
import { UserRoundCog } from 'lucide-react';
import { useLanguage } from "../context/LanguageProvider";

export default function RoleCard({ role,fetchRoles }) {
  const { token } = useAuth();
  const { t } = useLanguage();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const deleteRole = async () => {
    setIsModalOpen(false); 

    try {
      const res = await fetch(BASE_URL+`/api/role/${role.id}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })

      if (res.ok) {
        toast.success("Delete reussi");
        fetchRoles();
      } else {
        const err = await res.json()
        toast.error("Delete failed");
      }
    } catch (error) {
      toast.error("Delete failed");
    }
  }
  
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    })
  }

  const getActivePermissions = () => {
    const permissions = [];
    for (const key in role) {
      if (
        key !== 'id' &&
        key !== 'name' &&
        key !== 'created_at' &&
        key !== 'updated_at' &&
        role[key] === 1
      ) {
        permissions.push(key.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase()));
      }
    }
    return permissions;
  };
  const activePermissions = getActivePermissions();

  return (
    <div className="group bg-white rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-500 overflow-hidden border border-gray-100 hover:-translate-y-2">
      <div className="px-4 pb-2 pt-4 bg-gradient-to-br from-gray-50 to-white border-b border-gray-100">
        <div className="flex items-center justify-between mb-2">
          <div className="w-10 h-10 bg-[var(--color-primary-50)] rounded-2xl flex items-center justify-center">
            <UserRoundCog className="h-5 w-5 text-[var(--color-primary-500)]" />
          </div>
          <span className="px-3 py-1 rounded-full text-[10px] font-semibold bg-[var(--color-primary-50)] text-[var(--color-primary-500)]">
            {t('roles.permissions_count', { count: activePermissions.length })}
          </span>
        </div>

        <h3 className="text-lg font-bold text-gray-900 group-hover:text-[var(--color-primary-500)] transition-colors duration-300">
          {role.name}
        </h3>
      </div>

      <div className="px-4 py-2">
        <h4 className="text-base text-xs font-semibold text-gray-800 mb-1">{t('roles.active_permissions')}:</h4>
        {activePermissions.length > 0 ? (
          <ul className="flex flex-wrap gap-x-1 gap-0.5 text-[9px] text-gray-700 h-32 overflow-y-auto custom-scrollbar pr-2">
            {activePermissions.map((permission, index) => (
              <li key={index} className="flex items-center text-[var(--color-primary-500)] px-1 pt-[1px] rounded-xl border border-[var(--color-primary-500)] bg-[var(--color-primary-50)] max-w-max max-h-max">
                <svg className="h-3.5 w-3.5 text-[var(--color-primary-500)] flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                {permission}
              </li>
            ))}
          </ul>
        ) : (
          <p className="text-sm h-32 text-gray-500 italic">{t('roles.no_permissions')}</p>
        )}

        <div className="flex items-center justify-between w-full">
          <div className="flex items-center text-[10px] text-gray-500 ">
          <svg className="h-4 w-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
            />
          </svg>
          {t('common.last_updated')} {formatDate(role.updated_at)}
         </div>
          <div className="flex gap-2">
              <Link to={`/roles/update/${role.id}`}>
              <button className="p-2 cursor-pointer border-2 border-gray-200 hover:border-[var(--color-primary-500)] text-gray-600 hover:text-[var(--color-primary-500)] rounded-xl transition-all duration-300">
                <svg className="h-3.5 w-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                  />
                </svg>
              </button>
            </Link>
            <button
                onClick={() => setIsModalOpen(true)} 
                className="p-2 cursor-pointer border-2 border-gray-200 hover:border-red-400 text-gray-600 hover:text-red-500 rounded-xl transition-all duration-300"
            >
              <svg className="h-3.5 w-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2
                  2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1
                  1 0 00-1-1h-4a1 1 0 00-1 1v3m5 0H6"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
      <DeleteModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          onConfirm={deleteRole}
        title={t('roles.delete_title')}
        message={t('roles.delete_message')}
          itemName={role.name}
        />
    </div>
  )
}
